import { render, staticRenderFns } from "./FormAnswer.vue?vue&type=template&id=04ad6293"
import script from "./FormAnswer.vue?vue&type=script&lang=js"
export * from "./FormAnswer.vue?vue&type=script&lang=js"
import style0 from "./FormAnswer.vue?vue&type=style&index=0&id=04ad6293&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports